module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3FwyJj/tc-custom/9780813139074.jpg?1703827418245",
      "alt": "This image is the cover for the book You've Come a Long Way, Baby"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("You've Come a Long Way, Baby\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“Provocative and diverse” essays on the image—and the reality—of feminism in the twenty-first century (Christine A. Kelly, author of "), _c('i', [_vm._v("Tangled Up in Red, White, and Blue")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" No matter what brand of feminism one may subscribe to, one thing is indisputable: the role of women in society during the past several decades has changed dramatically, and continues to change in a variety of ways. In "), _c('i', [_vm._v("You’ve Come a Long Way, Baby,")]), _vm._v(" Lilly J. Goren and an impressive group of contributors explore the remarkable advancement achieved by American women in a historically patriarchal social and political landscape, while examining where women stand today and contemplating the future challenges they face worldwide. As comprehensive as it is accessible, "), _c('i', [_vm._v("You’ve Come a Long Way, Baby")]), _vm._v(" appeals to anyone interested in confronting the struggles and celebrating the achievements of women in modern society."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Some of the articles are down-to-earth, some are down-and-dirty. Some are matter-of-fact, others deliberately argumentative in tone. The book itself is a treasury.” —"), _c('i', [_vm._v("Lincoln County News")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lilly J. Goren\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lilly J. Goren is associate professor of politics and global studies at Carroll University in Waukesha, Wisconsin.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University Press of Kentucky\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0